import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { TutorialFactoryService } from "./tutorial-factory.service";
import { TutorialTooltipComponent } from "./tutorial-tooltip.component";

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [TutorialTooltipComponent],
  exports: [TutorialTooltipComponent],
  providers: [TutorialFactoryService]
})
export class TutorialModule {}
